import { render, staticRenderFns } from "./QnA.vue?vue&type=template&id=5e9c7d06&scoped=true"
import script from "./QnA.vue?vue&type=script&lang=js"
export * from "./QnA.vue?vue&type=script&lang=js"
import style0 from "./QnA.vue?vue&type=style&index=0&id=5e9c7d06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9c7d06",
  null
  
)

export default component.exports